import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import { space4XL, spaceXXL, spaceXL, spaceL, spaceM } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

export const ContentSpacer = styled.div`
  margin-top: ${spaceXL};
  margin-bottom: calc(${space4XL} + ${spaceXXL} + ${spaceM});
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceL};

  @media ${mediaConfined} {
    margin-bottom: ${spaceXXL};
  }
`;
